<template>
  <div
    class="loading-overlay"
    :class="{show: show}"
  >
    <div class="loading-wrapper">
      <img
        class="indicator"
        src="/img/loading.svg"
        alt=""
      >
      <slot
        v-if="text"
        name="text"
      >
        <span>
          {{ text }}
        </span>
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Please wait...',
    },

  },
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
  background: rgba(0, 0, 0, 0.8);
  transition: 0.2s;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;

  &.show {
    opacity: 1;
    visibility: visible;
  }

  .indicator {
    -webkit-animation: spin 2s infinite linear;
  }

  .loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      margin-top: 10px;
      text-transform: uppercase;
      font-weight: 600;
      font-size: 14px;
      color: var(--color-secondary);
    }
  }
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

</style>
